async function postJson(
  path: string,
  body: unknown
): Promise<{ ok: boolean; data: { message?: string; error?: string } }> {
  const res = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data: { message?: string; error?: string } = {};
  try {
    data = await res.json();
  } catch {
    /* non-JSON error bodies */
  }
  return { ok: res.ok, data };
}

export const AuthService = {
  forgotPassword: (email: string) => postJson("/api/forgot-password", { email }),
  resetPassword: (token: string, newPassword: string) =>
    postJson("/api/reset-password", { token, newPassword }),
  verifyEmail: (token: string) => postJson("/api/verify-email", { token }),
  resendVerification: (email: string) => postJson("/api/resend-verification", { email }),
};
